import { render, staticRenderFns } from "./HSAccessRecord.vue?vue&type=template&id=6fdec64e&scoped=true&"
import script from "./HSAccessRecord.vue?vue&type=script&lang=js&"
export * from "./HSAccessRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdec64e",
  null
  
)

component.options.__file = "HSAccessRecord.vue"
export default component.exports